import React, { useRef, useEffect } from "react";
import * as d3 from "d3";

const RadarChart = ({ data, width = 800, height = 375 }) => {
    const svgRef = useRef();
    const tooltipRef = useRef();

    useEffect(() => {
        const levels = 5;
        const maxValue = 6;

        const allAxis = data.map(d => d.category);
        const total = allAxis.length;
        const radius = Math.min(width / 2, height / 2) - 40;
        const angleSlice = (Math.PI * 2) / total;

        d3.select(svgRef.current).selectAll("*").remove();

        const svg = d3.select(svgRef.current)
            .attr("width", width)
            .attr("height", height);

        const g = svg.append("g")
            .attr("transform", `translate(${width / 2},${height / 2 - 20})`);

        const tooltip = d3.select(tooltipRef.current);

        // Grid circles
        for (let level = 0; level <= levels; level++) {
            const r = (radius / levels) * level;
            g.append("circle")
                .attr("r", r)
                .style("fill", "none")
                .style("stroke", "#CDCDCD")
                .style("stroke-dasharray", "2,2");
        }

        // Axis lines and labels
        allAxis.forEach((axis, i) => {
            const angle = i * angleSlice;
            const x = radius * Math.cos(angle - Math.PI / 2);
            const y = radius * Math.sin(angle - Math.PI / 2);

            g.append("line")
                .attr("x1", 0)
                .attr("y1", 0)
                .attr("x2", x)
                .attr("y2", y)
                .attr("stroke", "#999");

            g.append("text")
                .attr("x", x * 1.1)
                .attr("y", y * 1.1)
                .attr("dy", "0.35em")
                .style("font-size", "12px")
                .style("text-anchor", "middle")
                .text(axis);
        });

        // Radar shape
        const line = d3.lineRadial()
            .radius(d => (d.average / maxValue) * radius)
            .angle((_, i) => i * angleSlice)
            .curve(d3.curveLinearClosed);

        g.append("path")
            .datum(data)
            .attr("d", line)
            .style("fill", "rgba(0,123,255,0.3)")
            .style("stroke", "#007BFF")
            .style("stroke-width", 2);

        // Data points
        g.selectAll(".dot")
            .data(data)
            .enter()
            .append("circle")
            .attr("class", "dot")
            .attr("cx", (d, i) => (d.average / maxValue) * radius * Math.cos(i * angleSlice - Math.PI / 2))
            .attr("cy", (d, i) => (d.average / maxValue) * radius * Math.sin(i * angleSlice - Math.PI / 2))
            .attr("r", 5)
            .attr("fill", "#007BFF")
            .on("mouseover", (event, d) => {
                tooltip
                    .style("display", "block")
                    .html(`<strong>${d.category}</strong><br/>Score: ${d.average}`);
            })
            .on("mousemove", (event) => {
                tooltip
                    .style("left", event.pageX + 10 + "px")
                    .style("top", event.pageY - 28 + "px");
            })
            .on("mouseout", () => {
                tooltip.style("display", "none");
            });

    }, [data]);

    return (
        <div style={{ textAlign: "center", position: "relative" }}>
            <svg ref={svgRef}></svg>

            <div
                ref={tooltipRef}
                style={{
                    position: "absolute",
                    textAlign: "center",
                    padding: "6px",
                    fontSize: "12px",
                    background: "#fff",
                    border: "1px solid #ccc",
                    borderRadius: "4px",
                    pointerEvents: "none",
                    display: "none",
                    boxShadow: "0 0 6px rgba(0,0,0,0.1)"
                }}
            ></div>
        </div>
    );
};

export default RadarChart;
